import { render, staticRenderFns } from "./PaymentPeriod.vue?vue&type=template&id=a0f80b8a&"
import script from "./PaymentPeriod.vue?vue&type=script&lang=ts&"
export * from "./PaymentPeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports